import { DiContainerInjectFn } from '@@/di/ts';
import { BuyerAccountOffersService } from './services/buyer-account-offers.service';
import { BuyerAccountPointsService } from './services/buyer-account-points.service';
import { BuyerAccount } from './services/buyer-account.service';

export default ((container) => {
  container.bind(BuyerAccountOffersService).to(BuyerAccountOffersService).inSingletonScope();
  container.bind(BuyerAccountPointsService).to(BuyerAccountPointsService).inSingletonScope();
  container.bind(BuyerAccount).to(BuyerAccount).inSingletonScope();
}) as DiContainerInjectFn;
